import type { RouteObject } from "react-router-dom";
import AppLayout from "@/components/feature/AppLayout";
import AuthGuard from "@/components/feature/AuthGuard";
import NotFound from "@/pages/NotFound";
import Dashboard from "@/pages/dashboard/page";
import Alerts from "@/pages/alerts/page";
import Predictions from "@/pages/predictions/page";
import Resources from "@/pages/resources/page";
import Organizations from "@/pages/organizations/page";
import Settings from "@/pages/settings/page";
import Reports from "@/pages/reports/page";
import Landing from "@/pages/landing/page";
import Login from "@/pages/login/page";
import Signup from "@/pages/signup/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Landing />,
  },
  {
    path: "/login",
    element: <Login />,
  },
  {
    path: "/signup",
    element: <Signup />,
  },
  {
    path: "/",
    element: (
      <AuthGuard>
        <AppLayout />
      </AuthGuard>
    ),
    children: [
      { path: "dashboard", element: <Dashboard /> },
      { path: "alerts", element: <Alerts /> },
      { path: "predictions", element: <Predictions /> },
      { path: "resources", element: <Resources /> },
      { path: "organizations", element: <Organizations /> },
      { path: "settings", element: <Settings /> },
      { path: "reports", element: <Reports /> },
    ],
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;